import React from 'react';
import styled from 'styled-components';
import FileIcon from './../icons/FileIcon';
import { getTranslatedString } from 'helpers/i18n';

const StyledFileMessage = styled.div`
  background: white;
  border: solid 1px #cccdd1;
  padding: 15px 15px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  font-weight: 300;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  text-decoration: none;
`;

const StyledAttachmentLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: -10px 0px;
`;

const StyledSentBy = styled.p`
  font-size: 9px;
  margin: 3px 0 0;
  margin-bottom: 0px;
  font-family: Circular;
`;

const StyledSentAt = styled.p`
  font-size: 9px;
  margin: 3px 0 0;
  font-family: Circular;
`;

const FileMessage = props => {
  return (
    <React.Fragment>
      <StyledFileMessage>
        <p>{props.data.text}</p>
        <StyledAttachmentLink
          href={props.data.url}
          target="_blank"
          download={props.data.fileName}
          rel="noopener noreferrer"
        >
          <FileIcon />
          <p style={{ margin: '0px' }}>{props.data.fileName}</p>
        </StyledAttachmentLink>
      </StyledFileMessage>
      <StyledSentBy>{props.data.author}</StyledSentBy>
      <StyledSentAt>
        {getTranslatedString('portal.messagingSentOn', {
          date: props.data.date,
          time: props.data.time,
        })}
      </StyledSentAt>
    </React.Fragment>
  );
};

export default FileMessage;
